import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import AnnouncementPopup from './components/AnnouncementPopup';
import LanguageRedirect from './components/LanguageRedirect';
import HreflangTags from './components/HreflangTags';

// Pages
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import PricingPage from './pages/PricingPage';
import FAQPage from './pages/FAQPage';
import ShippingPage from './pages/ShippingPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="min-h-screen bg-white flex flex-col">
          <AnnouncementPopup />
          <HreflangTags />
          <LanguageRedirect />
          <Navigation />
          <main className="flex-grow">
            <Routes>
              {/* Finnish routes */}
              <Route path="/fi" element={<HomePage />} />
              <Route path="/fi/palvelut" element={<ServicesPage />} />
              <Route path="/fi/hinnasto" element={<PricingPage />} />
              <Route path="/fi/ukk" element={<FAQPage />} />
              <Route path="/fi/toimitus" element={<ShippingPage />} />
              <Route path="/fi/yhteystiedot" element={<ContactPage />} />
              <Route path="/fi/tietosuoja" element={<PrivacyPage />} />
              <Route path="/fi/ehdot" element={<TermsPage />} />

              {/* English routes */}
              <Route path="/en" element={<HomePage />} />
              <Route path="/en/services" element={<ServicesPage />} />
              <Route path="/en/pricing" element={<PricingPage />} />
              <Route path="/en/faq" element={<FAQPage />} />
              <Route path="/en/shipping" element={<ShippingPage />} />
              <Route path="/en/contact" element={<ContactPage />} />
              <Route path="/en/privacy" element={<PrivacyPage />} />
              <Route path="/en/terms" element={<TermsPage />} />

              {/* Swedish routes */}
              <Route path="/sv" element={<HomePage />} />
              <Route path="/sv/tjanster" element={<ServicesPage />} />
              <Route path="/sv/priser" element={<PricingPage />} />
              <Route path="/sv/faq" element={<FAQPage />} />
              <Route path="/sv/leverans" element={<ShippingPage />} />
              <Route path="/sv/kontakt" element={<ContactPage />} />
              <Route path="/sv/integritet" element={<PrivacyPage />} />
              <Route path="/sv/villkor" element={<TermsPage />} />

              {/* Old URL redirects (for SEO - keeps old links working) */}
              <Route path="/palvelut" element={<Navigate to="/fi/palvelut" replace />} />
              <Route path="/hinnasto" element={<Navigate to="/fi/hinnasto" replace />} />
              <Route path="/ukk" element={<Navigate to="/fi/ukk" replace />} />
              <Route path="/toimitus" element={<Navigate to="/fi/toimitus" replace />} />
              <Route path="/yhteystiedot" element={<Navigate to="/fi/yhteystiedot" replace />} />
              <Route path="/privacy" element={<Navigate to="/fi/tietosuoja" replace />} />
              <Route path="/terms" element={<Navigate to="/fi/ehdot" replace />} />

              {/* Root redirect to Finnish (or detected language) */}
              <Route path="/" element={<Navigate to="/fi" replace />} />

              {/* Catch-all: redirect unknown routes to home */}
              <Route path="*" element={<Navigate to="/fi" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
};

export default App;
